import { useCallback } from "react";
import { Flex, Text } from "@radix-ui/themes";
import { ChatReleaseGurad } from "@/v2/features/simulator/parts/chat";
import { Simulator } from "@/api/simulator/simulator.model";
import { SelectSimulation } from "@/api/simulator/SelectSimulation";

interface SimulatorPickerProps {
  simulatorId: string;
  onSimulatorChange: (simulatorId: string) => void;
  simulators?: Simulator[];
  loading?: boolean;
}

function SimulatorPicker({
  simulatorId,
  onSimulatorChange,
  simulators,
  loading,
}: SimulatorPickerProps) {
  const handleSimulatorChange = useCallback(
    (simulatorId: number) => {
      onSimulatorChange(simulatorId.toString());
    },
    [onSimulatorChange]
  );

  return (
    <SelectSimulation
      value={+simulatorId}
      onChange={handleSimulatorChange}
      simulators={simulators}
      loading={loading}
      classes={{ root: "w-full" }}
      aria-labelledby="agent-label"
    />
  );
}

interface ChatWithSkillProps {
  simulatorId: string;
  onSimulatorChange: (simulatorId: string) => void;
  simulators?: Simulator[];
  loading: boolean;
}

export function ChatWithSkill({
  simulatorId,
  onSimulatorChange,
  simulators,
  loading,
}: ChatWithSkillProps) {
  return (
    <Flex
      width="40%"
      minWidth="500px"
      direction="column"
      className="border-l border-[var(--q-border)] shadow-md"
    >
      <Flex
        py="4"
        px="6"
        direction="column"
        gap="2"
        className="border-b border-[var(--q-border)] shadow-sm"
      >
        <Text size="2" weight="medium" color="gray" as="label" id="agent-label">
          Agent
        </Text>
        <SimulatorPicker
          simulatorId={simulatorId}
          onSimulatorChange={onSimulatorChange}
          simulators={simulators}
          loading={loading}
        />
      </Flex>

      <Flex flexGrow="1" overflow="hidden">
        <ChatReleaseGurad setIsLoadingMessages={() => {}} />
      </Flex>
    </Flex>
  );
}
